/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Filter_In_PaymentInputs */

const en_cases_filter_in_payment = /** @type {(inputs: Cases_Filter_In_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Payment`)
};

const pt_br2_cases_filter_in_payment = /** @type {(inputs: Cases_Filter_In_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em Pagamento`)
};

/**
* | output |
* | --- |
* | "In Payment" |
*
* @param {Cases_Filter_In_PaymentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_filter_in_payment = /** @type {((inputs?: Cases_Filter_In_PaymentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Filter_In_PaymentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_filter_in_payment(inputs)
	return pt_br2_cases_filter_in_payment(inputs)
});